module.exports = __webpack_public_path__ + "img/56.6f7a3d98.jpg";